import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProxmoxService } from '../../../services/proxmox.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-log-in',
  templateUrl: './log-in.component.html',
  styleUrls: ['./log-in.component.scss']
})
export class LogInComponent implements OnInit {
  username: string = 'cloud@pve';
  password: string = '@<0w6@.>t*:y?wA';
  useApiToken: boolean = false;
  apiToken: string = 'PVEAPIToken=root@pam!cloud=fc2bc35d-1107-4887-be1b-8617c970c518';
  errorMessage: string = '';
  isLoading: boolean = false;
  connectionTestResult: string = '';

  constructor(
    private proxmoxService: ProxmoxService,
    private router: Router,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    // If already logged in, redirect to proxmox api explorer page
    if (this.proxmoxService.isAuthenticated()) {
      this.router.navigate(['/proxmox-api-explorer']);
    }
  }

  /**
   * Test connection to Proxmox API
   */
  testConnection(): void {
    this.connectionTestResult = 'Testing connection...';
    
    // First test direct connectivity to proxy
    this.http.get('http://localhost:3001/health').subscribe({
      next: (response) => {
        this.connectionTestResult = 'Proxy health check successful: ' + JSON.stringify(response);
        
        // Now test Proxmox API connection
        this.proxmoxService.testConnection().subscribe({
          next: (response) => {
            this.connectionTestResult += '\n\nProxmox API connection successful: ' + JSON.stringify(response);
          },
          error: (error) => {
            this.connectionTestResult += '\n\nProxmox API connection failed: ' + error;
            console.error('Proxmox API connection error:', error);
          }
        });
      },
      error: (error) => {
        this.connectionTestResult = 'Proxy health check failed. The proxy server may not be running: ' + JSON.stringify(error);
        console.error('Proxy health check error:', error);
      }
    });
  }

  /**
   * Handle login form submission
   */
  onLogin(): void {
    this.isLoading = true;
    this.errorMessage = '';

    if (this.useApiToken) {
      // Set the API token
      this.proxmoxService.setApiToken(this.apiToken);
      
      // Test the API token authentication by making an authenticated API call
      this.proxmoxService.testAuthenticatedConnection().subscribe({
        next: (response) => {
          this.isLoading = false;
          console.log('API token authentication successful, response:', response);
          // Redirect to proxmox api explorer page after successful authentication
          this.router.navigate(['/proxmox-api-explorer']);
        },
        error: (error) => {
          this.isLoading = false;
          console.error('API token authentication error:', error);
          this.errorMessage = 'API token authentication failed. Please check your API token.';
        }
      });
    } else {
      // Use traditional username/password login
      console.log('Attempting login with username:', this.username);
      this.proxmoxService.login(this.username, this.password).subscribe({
        next: (response) => {
          this.isLoading = false;
          console.log('Login successful, response:', response);
          // Redirect to proxmox api explorer page after successful login
          this.router.navigate(['/proxmox-api-explorer']);
        },
        error: (error) => {
          this.isLoading = false;
          console.error('Login error:', error);
          
          // Provide more detailed error information
          if (typeof error === 'string' && error.includes('CORS')) {
            this.errorMessage = 'CORS error: Unable to connect to Proxmox server.\n\n' +
                              'Please ensure:\n' +
                              '1. You are running the application with "npm start" command\n' +
                              '2. The proxy.conf.json file exists and is properly configured\n' +
                              '3. The Proxmox server at 172.16.16.10:8006 is accessible\n' +
                              '4. There are no network/firewall restrictions\n\n' +
                              'Detailed error: ' + error;
          } else if (typeof error === 'string' && error.includes('Invalid username or password')) {
            this.errorMessage = 'Invalid username or password. Please check your credentials.';
          } else if (typeof error === 'string' && error.includes('404')) {
            this.errorMessage = 'API endpoint not found. Please check the Proxmox server configuration and ensure it is running.';
          } else if (typeof error === 'string') {
            this.errorMessage = error;
          } else {
            this.errorMessage = 'Login failed. Please check your credentials.';
          }
        }
      });
    }
  }
}